const ITEMS = [
  "Zero account required",
  "Real-time shadow tracking",
  "Parking • Camping • Sunbathing",
  "Privacy preserved",
  "Solar azimuth live",
  "Comfort-zones validated",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-b border-[var(--sp-line)] bg-[var(--sp-surface)] py-5"
    >
      <div className="marquee-track flex w-max items-center gap-24 pr-24">
        {row.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center gap-24">
            <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-[var(--sp-muted)]">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[var(--sun)]" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
